async function fetchJSON(url) {
  const response = await fetch(url);
  const json = await response.json();
  return json;
}

export {
  fetchJSON,
};



// WEBPACK FOOTER //
// ./src/fetch.js